/* istanbul ignore file */ /* this file is not used or will be deleted in other branches */
// @ts-nocheck
import { get, chain, isUndefined } from 'lodash';
import moment from 'moment';
import {
  requiredMultiValidator,
  requiredMultiWithStartDate,
  dateInFuture,
  SpecialCasesEntryType,
  chronicCareFieldValidation
} from './validator-utils';

const phoneNumberPattern = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;

// https://ui.dev/validate-email-address-javascript/
const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const phoneExtentionPattern = /^[0-9]{1,3}$/;

const validatorMapper = {
  /**
   * Text fields validators
   */
  email: () => (value) => !value || emailPattern.test(value) ? undefined : `Invalid email`,

  phone: () => (value) => !value || phoneNumberPattern.test(value) ? undefined : `Invalid phone number`,

  phoneExtension: () => (value) => !value || phoneExtentionPattern.test(value) ? undefined : 'Inavlid phone extension',

  multi: () => (values) =>
    !values.length || !values.filter((value) => !value.start_dt).length ? undefined : 'Start date required',

  zipCode: () => (value) => !value || /^[0-9]{5,5}$/.test(value) ? undefined : `Invalid Zip code`,

  textWithSpecialCharacters: () => (value) =>
    !value || /^[A-Za-z'-]+$/.test(value) ? undefined : `Approved special characters include - and '`,

  requiredIf:
    ({ field: { name, value, valuePath } }) =>
    (currentValue, formState, meta) => {
      const entityPath =
        valuePath || // valuePath is used for directly specified path
        chain(meta) // meta is used to get the object field value on the same level as the property we want to validate
          .get('name')
          .split('.')
          .dropRight()
          .concat(name)
          .join('.')
          .value();

      return isUndefined(currentValue) && get(formState, entityPath) === value ? 'Required' : undefined;
    },

  requiredIfFieldSet:
    ({ fields }) =>
    (currentValue, formState) => {
      if (fields.some((valueAccessor) => get(formState, valueAccessor, false))) {
        return currentValue ? '' : 'Required';
      }

      return '';
    },

  chronicCareFieldValidation: () => chronicCareFieldValidation,

  /**
   * End Text fields validators
   */
  /**
   * Dates validators
   */
  dateAfter:
    ({ after: { name, label } }) =>
    (value, formState) =>
      formState[name] && value && value < formState[name] ? `This date has to be after ${label}` : '',
  dateInFuture: () => (value) => dateInFuture(value) ? '' : 'This date should be in a future',
  dateInPast: () => (value) => value && dateInFuture(value) ? 'Date must be in past' : undefined,
  optionalDateInFuture: () => (value) => {
    if (!value) {
      return '';
    }

    return dateInFuture(value) ? '' : 'This date should be in a future';
  },
  date: () => (value) => {
    return moment(value).isValid() ? '' : 'The value should be valid date';
  },
  /**
   * End Dates validators
   */

  /**
   * Special cases validators
   */
  optionalIfTermedGroupOrWithRegType:
    ({ regType, entryType }) =>
    (value, formState, meta) => {
      const groupPath = chain(meta).get('name').split('.').dropRight(2);
      const terminationDate = get(formState, groupPath.concat('end_dt').join('.').value());
      const registrationType = get(formState, groupPath.concat('reg_type').join('.').value());

      if (Array.isArray(regType) && regType.includes(registrationType)) return;
      if (regType === registrationType) return;

      if (!terminationDate || moment.utc(terminationDate).isAfter(moment.utc())) {
        switch (entryType) {
          case SpecialCasesEntryType.array:
            return requiredMultiValidator(value) ? undefined : 'Required';
          case SpecialCasesEntryType.arrayWithStartDate:
            return requiredMultiWithStartDate(value) ? undefined : 'Start date required';
          default:
            return value ? undefined : 'Required';
        }
      }
    },

  conditionallyOptionalMultiPbPlanCodes: () => (values, formState, meta) => {
    const groupPath = chain(meta).get('name').split('.').dropRight(2);
    const terminationDate = get(formState, groupPath.concat('end_dt').join('.').value());
    const regType = get(formState, groupPath.concat('reg_type').join('.').value());

    if (regType === 'client site') return;
    if (!terminationDate || moment.utc(terminationDate).isAfter(moment.utc())) {
      return requiredMultiWithStartDate(values) ? undefined : 'Start date required';
    }
  }
  /**
   * End Special cases validators
   */
};

export default validatorMapper;
